// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 0px) and (max-width: 767px) {
  .search_results_first_section {
    display: none;
  }
  .mobile_view_for_first_section {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  .search_results_tab_container {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 40px;
  }
  .search_results_list_container_card_mobile {
    cursor: pointer;
    border-radius: 9px;
    box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    overflow: hidden;
    height: max-content;
  }
  .load_more_container {
    margin-bottom: 20px;
  }
  .tab_container_trending_results {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
  }
  .search_results_container_trending_results > .fact_check_trending_container {
    width: 100% !important;
  }
  .search_results_container_trending_results
    > .tab_container_trending_results
    > .trending_now_container
    > .trending_now_content {
    padding: 0px !important;
    margin-top: 0px;
  }
  .search_results_container_trending_results
    > .tab_container_trending_results
    > .trending_now_container
    > .trending_now_content
    > .fact_check_trending_container {
    width: auto !important;
    margin: 0px !important;
    margin-top: 20px !important;
  }
  .search_result_card_skeleton_width {
    width: 100%;
    margin: 10px;
    height: 200px;
  }
  .search_results_card {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
    position: relative;
  }
  .search_results_container{
    height: 300px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_767/screen_767_search_results.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,oDAAoD;IACpD,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;;;;IAIE,uBAAuB;IACvB,eAAe;EACjB;EACA;;;;;IAKE,sBAAsB;IACtB,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,oDAAoD;IACpD,kBAAkB;EACpB;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .search_results_first_section {\n    display: none;\n  }\n  .mobile_view_for_first_section {\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n  }\n  .search_results_tab_container {\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    margin-bottom: 40px;\n  }\n  .search_results_list_container_card_mobile {\n    cursor: pointer;\n    border-radius: 9px;\n    box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 20px;\n    overflow: hidden;\n    height: max-content;\n  }\n  .load_more_container {\n    margin-bottom: 20px;\n  }\n  .tab_container_trending_results {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n  }\n  .search_results_container_trending_results > .fact_check_trending_container {\n    width: 100% !important;\n  }\n  .search_results_container_trending_results\n    > .tab_container_trending_results\n    > .trending_now_container\n    > .trending_now_content {\n    padding: 0px !important;\n    margin-top: 0px;\n  }\n  .search_results_container_trending_results\n    > .tab_container_trending_results\n    > .trending_now_container\n    > .trending_now_content\n    > .fact_check_trending_container {\n    width: auto !important;\n    margin: 0px !important;\n    margin-top: 20px !important;\n  }\n  .search_result_card_skeleton_width {\n    width: 100%;\n    margin: 10px;\n    height: 200px;\n  }\n  .search_results_card {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n    border-radius: 10px;\n    box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n    position: relative;\n  }\n  .search_results_container{\n    height: 300px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
